<template>
    <div class="container">
        <div class="nav_header">
            <h2>我购买的商标</h2>
        </div>

        <div class="toolbar">
            <div class="left">
                <el-select
                    v-model="step"
                    placeholder="订单进度"
                    size="medium "
                    @change="(e) => on_field_change(e, 'step')"
                    style="width:110px"
                    class="item"
                >
                    <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value"> </el-option>
                </el-select>

                <el-select
                    v-model="dateType"
                    placeholder="时间类型"
                    size="medium"
                    @change="handleDateChange"
                    style="width:110px; "
                    class="item"
                >
                    <el-option v-for="item in dateTypeOptions" :key="item.label" :label="item.label" :value="item.value"> </el-option>
                </el-select>

                <el-date-picker
                    @change="handleDateChange"
                    v-model="dateBetween"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="picker_options"
                    class="item"
                >
                </el-date-picker>
            </div>
            <div style="right">
                <el-input placeholder="搜索" v-model="wd">
                    <el-button slot="append" icon="el-icon-search" @click="on_search" type="primary"></el-button>
                </el-input>
            </div>
        </div>

        <template v-if="searchMode">
            <white-space />
            <el-alert
                :title="'共搜索到' + pagination.total + '条结果'"
                type="info"
                close-text="清除搜索"
                show-icon
                @close="$router.push(path)"
            ></el-alert>
        </template>

        <div class="main_list" v-loading="loading">
            <el-card
                class="box-card"
                shadow="hover"
                v-for="item in data_source"
                :key="item.order_no"
                style="margin-bottom:24px;position: relative;"
                :body-style="{ padding: '18px 20px' }"
            >
                <div class="postmark" v-if="item.completed_at">
                    <i v-if="item.status == -1" class="iconfont icon-yiquxiao cancel"></i>
                    <i v-if="item.status == 1" class="iconfont icon-yiwancheng success"></i>
                </div>
                <div slot="header" class="card-header">
                    <div>
                        <!-- <span style="padding-right:24px;" >
                      <img :src="'https://static.711.cn/material/icon/v1/'+item.taxonomy+'.png'" style="width:25px" :title="item.taxonomy_texx"/>
                    </span> -->
                        <span style="font-size: 14px;padding-right:24px;color:#9E9E9E"
                            >订单号：<a @click="$router.push('/order_trademark/' + item.order_no)">{{ item.order_no }} </a></span
                        >
                        <span style="font-size: 14px;padding-right:24px;color:#9E9E9E"
                            >下单时间：{{ item.created_at | dateformat("YYYY-MM-DD HH:mm") }}</span
                        >

                        <span style="font-size: 14px;padding-right:24px;color:#9E9E9E">金额：￥{{ item.amount }}</span>

                        <span style="font-size: 14px;padding-right:24px;color:#F44336" v-if="item.amount_refunded > 0"
                            >已退款：￥{{ item.amount_refunded }}</span
                        >

                        <el-button
                            style="float: right; padding: 3px 0"
                            type="text"
                            @click="$router.push('/order_trademark/' + item.order_no)"
                            class="pointer"
                        >
                            <span class="pointer">详细</span>
                            <i class="el-icon-right el-icon--right"></i>
                        </el-button>

                        <el-button
                            style="float: right; padding: 3px 0;margin-right:12px;"
                            type="text"
                            @click="on_pay_deposit_pre(item)"
                            class="pointer"
                            v-if="item.status == 0 && item.step == 'created'"
                        >
                            <span class="pointer">支付定金</span>
                        </el-button>
                    </div>
                </div>

                <div class="text item">
                    <div class="detail">
                        <div class="icon">
                            <img :src="item.thumbnail" />
                        </div>
                        <div class="info">
                            <div class="title">
                                <!-- <a class="link" :href="config.special_url + '/' + item.type + '/' + item.resource_id" target="_blank"
                                    >{{ item.name }}
                                </a> -->
                                {{ item.name }}
                            </div>
                            <div class="id">商标注册号：{{ item.apply_no }}</div>
                        </div>
                    </div>

                    <el-steps :active="item.step_digit" finish-status="success" simple style="margin-top: 20px">
                        <el-step title="合同"></el-step>
                        <el-step title="首付款"></el-step>
                        <el-step title="公证书"></el-step>
                        <el-step title="尾款"></el-step>
                        <el-step title="发票"></el-step>
                        <el-step title="完成"></el-step>
                    </el-steps>

                    <el-alert
                        title="请及时支付预定定金，已避免商标被其他人购买。"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="margin-top:18px;"
                        v-if="item.status == 0 && item.step == 'created'"
                    >
                    </el-alert>
                </div>
            </el-card>
            <div v-show="data_source.length">
                <el-pagination
                    style="text-align:center;margin-top:24px;"
                    background
                    layout="total,prev, pager, next"
                    :total="pagination.total"
                    :current-page="pagination.current_page"
                    :page-size="pagination.per_page"
                    @current-change="handle_current_change"
                >
                </el-pagination>
            </div>

            <Empty v-if="!data_source.length" />
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import common from "./common.js";
    import orderPay from "../../mixins/OrderPay.vue";
    export default {
        mixins: [orderPay, common],
        data() {
            return {
                path: "/order_trademark",
                loading: true,
                data_source: [],
                step: "",
                length: 0,
                money: 0,
                searchMode: false,
                password_pay: null,
                itemColumn: [
                    {
                        title: "",
                        dataIndex: "item_id",
                    },
                    {
                        title: "",
                        dataIndex: "subject",
                    },
                    {
                        title: "",
                        dataIndex: "content",
                    },
                    {
                        title: "",
                        dataIndex: "price",
                    },
                    {
                        title: "",
                        dataIndex: "process_status_text",
                    },
                ],
                options: [
                    {
                        value: "",
                        label: "全部订单",
                    },
                    {
                        value: "created",
                        label: "创建",
                    },
                    {
                        value: "deposit",
                        label: "定金",
                    },
                    // {
                    //     value: "verify",
                    //     label: "验店",
                    // },
                    {
                        value: "contract",
                        label: "合同",
                    },
                    {
                        value: "balance",
                        label: "尾款",
                    },
                    {
                        value: "complete",
                        label: "完成/终止",
                    },
                ],
                value: "",
                dateBetween: "",
                dateTypeOptions: [
                    {
                        label: "下单时间",
                        value: "created_at",
                    },
                    {
                        label: "支付时间",
                        value: "paid_at",
                    },
                    {
                        label: "完成时间",
                        value: "completed_at",
                    },
                ],
                dateType: "created_at",
            };
        },
        watch: {
            $route() {
                this.load();
                // this.parse_query();
            },
        },
        mounted() {
            this.load();
            this.parse_query();
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/order_trademark?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            parse_query() {
                const query = this.$route.query;
                this.step = Object.prototype.hasOwnProperty.call(query, "step") ? query["step"] : "";
            },
            handleDateChange() {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query[this.dateType] = this.dateBetween ? this.dateBetween.join(",") : "";
                query["_search"] = 1;

                this.$router.push(`/order_trademark?${this.objectToQuery(query)}`);
            },
            changeFun(val) {
                this.multipleSelection = val;
                this.length = val.length;
            },
        },
    };
</script>

<style scoped lang="less">
    .postmark {
        width: 100px;
        height: 100px;
        display: inline-block;
        position: absolute;
        z-index: 1;
        right: 0;
        margin-right: 30px;
        margin-top: -50px;
        top: 50%;
        opacity: 0.7;
        .iconfont {
            font-size: 84px;
            position: absolute;
            &.success {
                color: #ff5722;
            }
            &.cancel {
                color: #9e9e9e;
            }
        }
    }

    .detail {
        display: flex;
        align-items: center;
        .icon {
            width: 30px;
            height: 30px;
            margin-right: 12px;
            img {
                width: 100%;
            }
        }
        .info {
            .title {
                font-size: 14px;
                margin-bottom: 4px;
            }
            .id {
                font-size: 12px;
                color: #9e9e9e;
            }
        }
    }
</style>
